import { useEffect, useState } from "react";
import { resolver } from "../../../API/middlewares/resolveRequests";
import {
  communityMembers,
  getCommunity,
} from "../../../API/store/actions/admin/communitiesAction";
import ModalComponent from "../../reusableComponents/modal";
import AddCommunityForm from "./addCommunity/addCommunityform";
import AddMember from "./addMembers";
import DeleteCommunity from "./deleteCommunity";

const CommunitiesAlerts = ({ userToken, modalVisible, setModalVisible }) => {
  const {
    addCommunity,
    deleteCommunity,
    editCommunity,
    helperData,
    addUser,
  } = modalVisible;
  const [data, setData] = useState(null);
  useEffect(() => {
    if (editCommunity) {
      setData(null);
      resolver(getCommunity, setData, helperData?.id, userToken);
    }
    if (addUser) {
      resolver(communityMembers, setData, helperData?.id, userToken);
    }
  }, [editCommunity, addUser]);
  return (
    <>
      {addCommunity ? (
        <ModalComponent
          hasImage={
            <img
              src={"/assets/images/Group 8277.png"}
              width={"100%"}
              height={"100%"}
            />
          }
          title={"إضافة محور عمل"}
          modalVisible={addCommunity}
          setModalVisible={() => {
            setModalVisible({ ...modalVisible, addCommunity: !addCommunity });
          }}
          body={
            <AddCommunityForm
              userToken={userToken}
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
            />
          }
        ></ModalComponent>
      ) : editCommunity ? (
        <ModalComponent
          title={"تعديل  محور العمل"}
          modalVisible={editCommunity}
          setModalVisible={() => {
            setData(null);
            setModalVisible({
              ...modalVisible,
              editCommunity: !editCommunity,
              helperData: null,
            });
          }}
          hasImage={
            <img
              src="/assets/images/greeniconedit.svg"
              width={20}
              height={20}
              alt=""
            />
          }
          body={
            data ? (
              <AddCommunityForm
                userToken={userToken}
                isEdit
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                data={data?.data}
              />
            ) : (
              <>LOADING</>
            )
          }
        ></ModalComponent>
      ) : deleteCommunity ? (
        <ModalComponent
          modalVisible={deleteCommunity}
          setModalVisible={() => {
            setModalVisible({
              ...modalVisible,
              deleteCommunity: !deleteCommunity,
            });
          }}
          body={
            <DeleteCommunity
              userToken={userToken}
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
            />
          }
          size={"s"}
          hasImage={
            <img
              src="/assets/images/deleteicon.png"
              width={20}
              height={20}
              alt=""
            />
          }
          title={"هل انت متاكد"}
          background={"modalBackground mx-5"}
        />
      ) : addUser ? (
        <ModalComponent
          modalVisible={addUser}
          setModalVisible={() => {
            setData(null);
            setModalVisible({
              ...modalVisible,
              addUser: !addUser,
              helperData: null,
            });
          }}
          body={
            data ? (
              <AddMember
                userToken={userToken}
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                data={data?.data}
              />
            ) : (
              <>LOADING</>
            )
          }
          hasImage={
            <img
              src={"/assets/images/Group 8275.png"}
              width={"100%"}
              height={"100%"}
            />
          }
          title={`اضافة عضو للبرنامج البحثي: ${helperData?.data?.userData?.name}`}
          background={"modalBackground mx-5"}
        />
      ) : null}
    </>
  );
};

export default CommunitiesAlerts;
